import React from 'react'
import TemplatizedTextField, {
    type TemplatizedTextFieldProps,
} from '@pushly/aqe/lib/components/templatized-text-field/templatized-text-field'

interface ITemplateBodyField extends TemplatizedTextFieldProps {}

const TemplateBodyField = (props: ITemplateBodyField) => {
    return (
        <TemplatizedTextField
            expandable={true}
            expandFieldName="Body"
            label="Body"
            mode="textarea"
            {...props}
            limits={{
                max: 140,
                aboveMaxMessage: 'Body may be cut off on some devices.',
                displayMode: 'custom',
            }}
        />
    )
}

export default TemplateBodyField
